import { ReturnTotalsType } from "@redotech/redo-model/returns/return-totals/return-totals-set";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getReturnTotalsFeatureFlag = {
  name: "getReturnTotalsFeatureFlag" as const,
  input: z.object({}),
  output: z.object({ returnTotalsTypeToUse: createEnum(ReturnTotalsType) }),
};
